import './App.css';
import Dashboard from './pages/Dashboard/Dashboard';
import { Route, Routes, Navigate } from "react-router-dom";
import { useState, useEffect } from 'react';

import SignIn from './pages/Auth/SignIn';
import Signup from './pages/Auth/SignUp';
import ForgotPassword from './pages/Auth/forgot-password';
import OtpVerification from './pages/Auth/OtpVerification';
import Profile_Details from './pages/Profile/Profile_Details';
import Change_Password from './pages/Change_Password/Change_Password';
import Setting from './pages/Setting/Setting';
import Loder from './components/Loding/Loder';
import GoogleTranslateLoader from './components/Translation/GoogleTranslateLoader';
import WalletControl from './pages/WalletControl/WalletControl';
import AddToWallet from './pages/WalletControl/AddToWallet';
import UpdateDonorProfile from './pages/UpdateProfile/UpdateDonorProfile';
import Reports from './pages/Reports​/Reports'
import ManagePromocode from './pages/ManagePromocode/PromocodeList';
import PromocodeDetails from './pages/ManagePromocode/PromocodeDetails';
import AddPromocode from './pages/ManagePromocode/AddPromocode';
import EditPromocode from './pages/ManagePromocode/EditPromocode';
import TransferToSchoolWallet from './pages/WalletControl/TransferToSchoolWallet';
import { DonorAuthenticate } from './api/apiHandler';
import { loginRedirectCallWithDataStore } from './pages/Common/RedirectPathMange';
import Swal from 'sweetalert2';

function App() {
  const [isLoading, setIsLoading] = useState(false);
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  function PrivateRoute({ children }) {
    const auth = localStorage.getItem('isDonorAdminLogin');
    return auth === 'true' ? <>{children}</> : <Navigate to="/sign-in" />;
  }

  useEffect(() => {
    const init = async () => {
      setIsLoading(true);
      const urlParams = new URLSearchParams(window.location.search);
      let token = urlParams.get('token');

      if (token) {
        token = token.replace(/ /g, '+');
        await authenticateDonor(token);
      } else {
        const isLoggedIn = localStorage.getItem("isDonorAdminLogin") === "true";
        if (!isLoggedIn) {
          console.log("No token and not logged in");
        }
      }
      setIsAuthChecked(true);
      setIsLoading(false);
    };

    init();
  }, []);

  const showLoder = (isLoading) => {
    setIsLoading(isLoading)
  }
  const getFlow = () => {
    const isLoggedIn = localStorage.getItem("isDonorAdminLogin") === "true";
    if (!isLoggedIn) {
      return (
        <>
          <Loder isActive={isLoading} />
          <Routes>
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/sign-up" element={<Signup type="e" isLoader={showLoder} />} />
            <Route path="/forgot-password" element={<ForgotPassword type="e" isLoader={showLoder} />} />
            <Route path="/otp-verification" element={<OtpVerification isLoader={showLoder} />} />
            <Route path="*" element={<SignIn />} />
          </Routes>
        </>
      )
    }
    else {
      return (
        <>
          <Loder isActive={isLoading} />
          <GoogleTranslateLoader />
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="/dashboard" element={<Dashboard isLoader={showLoder} />} />
            <Route path="/profiledetails" element={<Profile_Details isLoader={showLoder} />} />
            <Route path='/update-profile' element={<UpdateDonorProfile isLoader={showLoder} />} />
            <Route path="/changepassword" element={<Change_Password isLoader={showLoder} />} />
            <Route path="/setting" element={<Setting isLoader={showLoder} />} />
            <Route path="/wallet-controls" element={<WalletControl isLoader={showLoder} />} />
            <Route path="/add-to-wallet" element={<AddToWallet isLoader={showLoder} />} />
            <Route path="/transfer-to-school-wallet" element={<TransferToSchoolWallet isLoader={showLoder} />} />
            <Route path="/reports" element={<Reports isLoader={showLoder} />} />
            <Route path='/manage-promocode' element={<ManagePromocode type="e" isLoader={showLoder} />} />
            <Route path='/promocode-details' element={<PromocodeDetails type="e" isLoader={showLoder} />} />
            <Route path='/add-promocode' element={<AddPromocode type="e" isLoader={showLoder} />} />
            <Route path='/edit-promocode' element={<EditPromocode type="e" isLoader={showLoder} />} />
          </Routes>
        </>
      )
    }
  }

  const authenticateDonor = async (token) => {
    try {
      const response = await DonorAuthenticate({ token: token })
      if (response.data.code == 1 || response.data.code == "1") {
        const data = response.data.data
        loginRedirectCallWithDataStore(data);
      } else {
        Swal.fire({
          title: "Authentication Failed",
          text: response.data.message || "Impresonate failed",
          icon: "error",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Authentication Failed",
        text: error || "Impresonate failed",
        icon: "error",
      });
    };
  };

  return (
    isAuthChecked ? getFlow() : <Loder isActive={true} />
  );
}


export default App;